import { FC } from 'react'

import {
  Box,
  Card,
  type DesignSystemTextProps,
  Spinner,
  Text,
} from '@factorialco/deprecated-design-system'

export const AnalyticsCard: FC<{
  title: string
  description: string
  count: number
  color?: DesignSystemTextProps['color']
  loading?: boolean
}> = ({ description, title, count, color = 'grey1000', loading }) => {
  return (
    <Card>
      <Card.Title>{title}</Card.Title>
      <Card.Description>{description}</Card.Description>
      <Card.Content>
        <Box height="full" justifyContent="flexEnd" paddingBottom="s24" paddingTop="s4">
          {!loading ? (
            <Text weight="semibold" size="800" color={color}>
              {count}
            </Text>
          ) : (
            <Spinner size="s16" />
          )}
        </Box>
      </Card.Content>
    </Card>
  )
}
